import React, { useState, useEffect } from 'react';

export const ScrollProgressIndicator = () => {
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = totalHeight > 0 ? Math.min(window.scrollY / totalHeight, 1) : 0;
      setScrollProgress(progress);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial call
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="fixed bottom-8 left-8 z-40">
      <div className="w-14 h-14 relative bg-white rounded-full shadow-lg">
        <svg className="w-full h-full transform -rotate-90">
          <circle
            cx="28"
            cy="28"
            r="24"
            fill="none"
            stroke="#E5E7EB"
            strokeWidth="3"
          />
          <circle
            cx="28"
            cy="28"
            r="24"
            fill="none"
            stroke="#264F77"
            strokeWidth="3"
            strokeDasharray={`${scrollProgress * 151} 151`}
            strokeLinecap="round"
            style={{ transition: 'stroke-dasharray 0.1s ease-out' }}
          />
        </svg>
        <div className="absolute inset-0 flex items-center justify-center text-xs font-semibold text-[#264F77]">
          {Math.round(scrollProgress * 100)}%
        </div>
      </div>
    </div>
  );
};
